module.exports = __webpack_public_path__ + "static/media/cover_maths_4_5_degree.288b4e9f.jpg";